import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://nspaxsuayceopswhpfmi.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5zcGF4c3VheWNlb3Bzd2hwZm1pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIzMzg2ODQsImV4cCI6MjA2NzkxNDY4NH0.TbazjGUCXAMpMFihjwDqFWmhYygeeAN4DW5lWDTTndc'; // From Supabase → Project → Settings → API

export const supabase = createClient(supabaseUrl, supabaseKey);

